import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { SEEDKEEPERS_URL } from "@/lib/api";
import { MEDIA } from "@/lib/media";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        kicker="About"
        title="Building Australia's Native Seed Future"
        subtitle="SeedKeepers Academy is a living centre for learning that has evolved from decades of practical work in native seed, ecological restoration and working on Country. It brings together field experience, ecological understanding and enterprise development to prepare the people and organisations shaping Australia's restoration future."
        image={MEDIA.floraLeaves}
      />

      <section className="bg-cream py-24 md:py-32">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-serif text-3xl md:text-4xl font-light leading-snug text-charcoal">
              SeedKeepers exists to strengthen the people, knowledge and practical systems required
              for native seed to support ecological recovery. The Academy develops the capability;
              the wider movement carries the work forward.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 text-charcoal/70 text-lg font-light leading-relaxed">
              We see native seed as ecological and cultural infrastructure — living material that
              connects past landscapes with future recovery. Our courses and on-country programs
              bring together ecological understanding, hands-on practice and learning grounded in
              place, so that individuals and organisations can collect, protect and use native seed
              with confidence and care.
            </p>
            <a href={SEEDKEEPERS_URL} target="_blank" rel="noopener noreferrer" data-testid="about-seedkeepers" className="group inline-flex items-center gap-2 mt-10 text-rainforest border-b border-ochre pb-1 hover:text-ochre transition-colors">
              Learn more about SeedKeepers <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </Reveal>
        </div>
      </section>

      <div className="bg-rainforest text-cream"><Marquee text="Native Seed Collection • Seed Banking • Propagation • Restoration Supply • On-Country Learning • Ranger Development • Seed Enterprises • Fire Recovery • Mine Rehabilitation • Biodiversity Restoration" /></div>

      <section className="bg-cream py-20 md:py-28">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-charcoal/40 mb-4">Recognition</p>
            <p className="text-charcoal/60 font-light leading-relaxed max-w-2xl">
              Participants who successfully complete a SeedKeepers Academy course or intensive
              receive a Certificate of Completion detailing the practical skills and areas of
              learning covered during the program.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
